import { useEffect, useState, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import AdminUserModal from "./modals/AdminUserModal";
import DeleteAdminModal from "./modals/DeleteAdminModal";
import { getAdminGridData,resetAuthKey  } from "../services/adminPanel_service";
import useAuthStore from "../../../store/authStore";
import editIcon from "../../../assets/images/grid_edit.gif";
import resetMfaIcon from "../../../assets/images/undo.gif";
import deleteIcon from "../../../assets/images/SBA/Delete.png";
import { toast } from "react-toastify";

const AdministratorsTab = () => {
    const userId = useAuthStore((state)=> state.user);
  const [rowData, setRowData] = useState([]);
  const [showModal, setShowModal] = useState(false);
const [modalMode, setModalMode] = useState("add");
const [selectedRow, setSelectedRow] = useState(null);
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteRow, setDeleteRow] = useState(null);

const handleAdd = () => {
  setModalMode("add");
  setSelectedRow(null);
  setShowModal(true);
};

const handleEdit = (row) => {
  setModalMode("edit");
  setSelectedRow(row);
  setShowModal(true);
};

const handleResetMfa = async (row) => {
  try{
    const payload = {
    UserId: row.userId,
    AuthKey : "",
    AuthToken:null,
    Type: (row.roleId === 1 || row.roleId === 2) ? "Admin" : "Contact"
  }
  await resetAuthKey(payload)
  toast.success("MFA reset successful.")
  }
  catch{
    toast.error("Failed to reset MFA.");
  }
};

const handleDelete = (row) => {
  setDeleteRow(row);
  setShowDeleteModal(true);
};

const ActionRenderer = (params) => {
  const row = params.data;

  return (
    <div style={{ display: "flex", gap: "8px" }}>
      <img
        src={editIcon}
        alt="Edit"
        title="Edit Admin User"
        style={{ cursor: "pointer", width: "16px" }}
        onClick={() => handleEdit(row)}
      />

      <img
        src={resetMfaIcon}
        alt="Reset MFA"
        title="Reset MFA"
        style={{ cursor: "pointer", width: "16px" }}
        onClick={() => handleResetMfa(row)}
      />

      <img
        src={deleteIcon}
        alt="Delete"
        title="Delete Admin User"
        style={{ cursor: "pointer", width: "16px" }}
        onClick={() => handleDelete(row)}
      />
    </div>
  );
};

  const formatDateTime = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();

        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";

        hours = hours % 12;
        hours = hours ? hours : 12;

        return `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;
    };

    const statusFormatter = (params) => {
        if (params.value === null || params.value === undefined) return "";
        return params.value ? "Active" : "InActive";
    };
    const yesNoFormatter = (params) => {
        if (params.value === null || params.value === undefined) return "";
        return params.value ? "Yes" : "No";
    };

    const getAdminCounts = (rows) => {
        const total = rows?.length;
        const active = rows?.filter(item => item.isActive)?.length;
        const inactive = rows?.filter(item => !item.isActive)?.length;
        const locked = rows?.filter(item => item.isLocked)?.length;
        return {total, active, inactive, locked}
    }

  const columnDefs = useMemo(() => [
    { headerName: "Status", field: "isActive", filter: true, cellRenderer: statusFormatter },
    { headerName: "Role", field: "roleName", filter: true },
    { headerName: "User Name", field: "userName", filter: true },
    { headerName: "First Name", field: "firstName", filter: true },
    { headerName: "Last Name", field: "lastName", filter: true },
    { headerName: "Locked", field: 'isLocked', filter: true, cellRenderer: yesNoFormatter},
    { headerName: "Email", field: "emailAddress", filter: true },
    { headerName: "Last Login", field: "lastLoginDate", valueFormatter: (params) => formatDateTime(params.value) },
    {
    headerName: "Actions",
    field: "actions",
    cellRenderer: ActionRenderer,
    filter: false,
    sortable: false,
    width: 120
  }
  ], []);

  useEffect(() => {
    loadAdmins();
  }, [userId]);

  const loadAdmins = async () => {
    try{
        const response = await getAdminGridData();
        setRowData(response.data);
    }
    catch{
        setRowData([])
    }
  };

  return (
    <>
      <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:'20px', marginTop:'20px'}}>
        <div style={{display:'flex', flexDirection:'row',gap: '10px'}}>
          <div><strong>Total Administrators:</strong> {getAdminCounts(rowData).total}</div>
          <div><strong>Active:</strong> {getAdminCounts(rowData).active}</div>
          <div><strong>InActive:</strong> {getAdminCounts(rowData).inactive}</div>
          <div><strong>Locked:</strong> {getAdminCounts(rowData).locked}</div>
        </div>

        <button
          className="btn btn-primary"
         onClick={handleAdd}
        >
          Add New Administrator
        </button>
      </div>

      <div
        className="ag-theme-alpine"
        style={{ height: 500, width: "100%" }}
      >
        <AgGridReact
        theme={'legacy'}
          rowData={rowData}
          columnDefs={columnDefs}
          pagination={true}
          animateRows={true}
           defaultColDef={{
            flex: 1,
            minWidth: 100,
            resizable: true,
          }}
        />
      </div>

      {showModal && (
  <AdminUserModal
    show={showModal}
    mode={modalMode}
    initialData={selectedRow}
    onClose={() => setShowModal(false)}
    onSuccess={loadAdmins}
  />
)}
{showDeleteModal && (
  <DeleteAdminModal
    show={showDeleteModal}
    selectedUser={deleteRow}
    onClose={() => setShowDeleteModal(false)}
    onSuccess={loadAdmins}
  />
)}
    </>
  );
};

export default AdministratorsTab;